export enum CMS_THEME {
  DARK = 'dark',
  LIGHT = 'light',
  NEUTRAL = 'neutral',
}

export enum CMS_OVERLAY {
  DARK = 'dark',
  LIGHT = 'light',
}

export enum PRODUCT_STATUS {
  FORMULA_UPDATE = 'Formula Update',
  PACKAGE_UPDATE = 'Package Update',
  SUPPLY_SHORTAGES = 'Supply Shortages',
  PRODUCT_RECALL = 'Product Recall',
  DISCONTINUED = 'Discontinued',
  NEW_PRODUCT = 'New Product',
}

// LaunchDarkly Keys.
export enum LD_KEYS {
  LD_USER_ID = 'ld-user-id',
}

export enum DefaultListingItemsPerPage {
  PRODUCT = 12,
  OFFER = 12,
  ARTICLE = 16,
}

export enum ListingPageType {
  PRODUCT = 'product_listing',
  ARTICLE = 'article_listing',
}

export enum PupUrls {
  PERKS = 'https://myprofile.purina.com',
  PETS = 'https://myprofile.purina.com/pets',
  ACCOUNT = 'https://myprofile.purina.com/account',
  PRIVACY_AND_LEGAL = 'https://myprofile.purina.com/privacy',
}

// https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types
export enum MimeType {
  IMAGE_JPEG = 'image/jpeg',
  IMAGE_JPG = 'image/jpg',
  IMAGE_PNG = 'image/png',
  APPLICATION_PDF = 'application/pdf',
}

export const isMimeType = (s: string): s is MimeType => {
  return Object.values(MimeType).includes(s as MimeType);
};

export const NerdMenuElementType = {
  BOLD: 'bold',
  COLUMN: 'column',
  COMPONENT: 'component',
  OUTLINED: 'outlined',
  LINK_LISTS_WRAPPER: 'link_lists_wrapper',
  LINK_LIST_HEADING: 'link_list_heading',
  MEGA_MENU_DROPDOWN: 'mega_menu_dropdown',
  MEGA_MENU_LINK: 'mega_menu_link',
  FILLED: 'filled',
  COOKIE_CONSENT: 'cookie_consent',
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type NerdMenuElementType = (typeof NerdMenuElementType)[keyof typeof NerdMenuElementType];

export const PupEnvironment = {
  PROD: 'PROD',
  STAGE: 'STAGE',
  LOCAL: 'LOCAL',
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type PupEnvironment = (typeof PupEnvironment)[keyof typeof PupEnvironment];
